import { Col, Image, Row } from 'antd';
import React from 'react';

import AnchorComponent from 'components/atoms/AnchorComponent';
import LanguageSelect from 'components/molecules/LanguageSelect';

import logoLogin from 'styles/images/logoLogin.svg';

interface Props {
    children?: React.ReactNode;
}

const AuthWrapper: React.FC<Props> = ({ children }) => {
    return (
        <>
            <Row className="auth-wrapper-row-main">
                <Col
                    span={8}
                    className={
                        window.location.hostname.includes('test')
                            ? 'auth-wrapper-col-logo-test'
                            : window.location.hostname.includes('styrax')
                              ? 'auth-wrapper-col-logo-dev'
                              : 'auth-wrapper-col-logo'
                    }
                >
                    <AnchorComponent
                        id="authWrapperCdcpREdirect"
                        onClick={() =>
                            window.location.replace(
                                window.location.href.includes('test') ? 'https://test.cdcp.cz' : 'https://www.cdcp.cz'
                            )
                        }
                    >
                        <Image
                            alt="logo"
                            src={logoLogin}
                            preview={false}
                            className="auth-wrapper-col-logo-img"
                            width="90%"
                        />
                    </AnchorComponent>

                    {(window.location.hostname.includes('test') || window.location.hostname.includes('styrax')) && (
                        <p
                            style={{
                                textAlign: 'center',
                                marginTop: '50%',
                                color: 'white',
                                fontSize: 40
                                // fontWeight: 'bold'
                            }}
                        >
                            {window.location.hostname.includes('styrax') ? 'DEV' : 'TEST'}
                        </p>
                    )}
                </Col>
                <Col span={16}>
                    <Row className="auth-wrapper-row-form">
                        <Col span={3} />
                        <Col span={18}>
                            {children}
                            <LanguageSelect
                                style={{
                                    position: 'absolute',
                                    top: '-90px',
                                    right: 0
                                }}
                            />
                        </Col>
                        <Col span={3} />
                    </Row>
                </Col>
            </Row>
        </>
    );
};

export default AuthWrapper;
